import React, { useEffect, useState } from 'react'
import TopSection from '../TopSection';
import Dropdown from "../../../components/common/Dropdown";
import TabSection from "../../../components/common/TabSection";
import ButtonComponent from "../../../components/common/button/Button";
import CustomSlider from './Slider';
import ExcelUpdate from './ExcelUpdate';
import { FileOverivew, FileOverivewFooter } from './FileOverview';
import Modal from '../../../components/common/modal/Modal'
import './index.css';
import { MultiDropdown } from '../../../components/common/MultiDropdown';
import RadioButtonGroup from '../../../components/common/RadioButtonGroup';
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { EditParameterConfigHeaders } from './EditParameterConfigHeaders';
import DataTable from '../../../components/common/datatable/DataTable';
import TextInput from '../../../components/common/TextInput';
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getParamConfigDropdownData } from '../../../redux/actions/Admin/ParamConfigDropdownDataSlice';
import { getParamConfigDropdownEndpoint, saveParamConfigEndpoint, searchParamConfigEndpoint, updateParamConfigSearchEndpoint } from '../../../common/endpoints';
import { Loader } from '../../../components/common/Loader';
import { getParamConfigMaterialSearch } from '../../../redux/actions/Admin/ParamConfigSearchMaterialSlice';
import { postParamConfigSave } from '../../../redux/actions/Admin/ParamConfigSaveSlice';
import { updateParamConfigSearch } from '../../../redux/actions/Admin/ParamConfigUpdateSlice';
import { Grid } from '@mui/material';

const ParamaterConfiguration = () => {
  const dispatch = useDispatch();
  const stateSelector = useSelector((state) => state);
  const { instance, accounts } = useMsal();
  const [fileName, setFileName] = useState('')
  const [show, setShow] = useState(false);
  const [xlDetails, setXLDetails] = useState({});
  const [formData, setFormData] = useState({
    plant: [],
    purchasingGroup: [],
    scode: [],
    materialType: [],
    supplierId: [],
    mrpController: [],
    materialId: [],
    materialGroup: [],
    variationThreshould: "percentage",
    lowSlider: [5, 20],
    mediumSlider: [21, 50],
    highSlider: [51, 999],
    workflowDays: 15,
    coolingPeriod: 90
  });
  const [selectedEditFormData, setSelectedEditFormData] = useState({});

  const [dropdownData, setDropdownData] = useState();
  const [plantData, setPlantData] = useState([]);
  const [purchasingGroupData, setPurchasingGroupData] = useState([]);
  const [scodeData, setScodeData] = useState([]);
  const [mrpControllerData, setMRPControllerData] = useState([]);
  const [supplierData, setSupplierData] = useState([]);
  const [materialGroupData, setMaterialGroupData] = useState([]);
  const [materialTypeData, setMaterialTypeData] = useState([]);
  const [materialIdData, setMaterialIdData] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [fileOverviewDetails, SetFileOverviewDetails] = useState({})
  const [isWindowFileSelected, setIsWindowFileSelected] = useState([]);
  const [poBenchmarkValue, setPOBenchmarkValue] = useState("");

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [isModifiedEditData, setIsModifiedEditData] = useState(false);
  const [excelLoader, setExcelLoader] = useState(false);
  const userRole = localStorage.getItem("LTRole");
  const pagePath = localStorage.getItem("LTPathName");

  const pagination = true;
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 30, 50, 100];

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      const uniqueValues = [...new Set(data?.map(item => item[key]))];
      return uniqueValues?.map(value => ({ label: value, value: value, title: value }));
    }
    else {
      return []
    }
  };

  const [value, setValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [thresholdValue, setThresholdValue] = useState("percentage");
  const [thresholdValueEdit, setThresholdValueEdit] = useState("percentage");
  const onChangeThresholdValue = (e) => {
    setThresholdValue(e.target.value);
    if (e.target.value !== "percentage") {
      setFormData((prevData) => ({
        ...prevData,
        lowSlider: [0, 150],
        mediumSlider: [151, 225],
        highSlider: [226, 999],
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        lowSlider: [5, 20],
        mediumSlider: [21, 50],
        highSlider: [51, 999],
      }));
    }
  }
  const onChangeThresholdValueEdit = (e) => {
    setThresholdValueEdit(e.target.value);
    setIsModifiedEditData(true);
    if (e.target.value !== "percentage") {
      setSelectedEditFormData((prevData) => ({
        ...prevData,
        lowRange1: 0,
        lowRange2: 150,
        mediumRange1: 151,
        mediumRange2: 225,
        highRange1: 226,
        highRange2: 999,
        coolingPeriod: 90,
        workflowDays: 15
      }));
    } else {
      setSelectedEditFormData((prevData) => ({
        ...prevData,
        lowRange1: 5,
        lowRange2: 20,
        mediumRange1: 21,
        mediumRange2: 50,
        highRange1: 51,
        highRange2: 999,
        coolingPeriod: 90,
        workflowDays: 15
      }));
    }
  }
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setShow(false);
    if(newValue === 0 || newValue === 2){
      handleClear();
    }
  };

  const handleChangeEditDropdown = (field, value) => {
    setIsModifiedEditData(true)
    setSelectedEditFormData((prev) => {
      let updatedFormData = { ...prev, [field]: value };

      // // Dependencies
      // if (field === "lowRange1") {
      //   updatedFormData.lowRange2 = value + 1;
      //   updatedFormData.mediumRange1 = updatedFormData.lowRange2 + 1;
      //   updatedFormData.mediumRange2 = updatedFormData.mediumRange1;
      //   updatedFormData.highRange1 = updatedFormData.mediumRange2;
      // }

      if (field === "lowRange2") {
        updatedFormData.mediumRange1 = value + 1;
      }

      if (field === "mediumRange2") {
        updatedFormData.highRange1 = value + 1;
      }

      return updatedFormData;
    });
  };

  const handleClear = () => {
    setFormData({
      plant: [],
      purchasingGroup: [],
      scode: [],
      materialType: [],
      supplierId: [],
      mrpController: [],
      materialId: [],
      materialGroup: [],
      variationThreshould: "percentage",
      lowSlider: [5, 20],
      mediumSlider: [21, 50],
      highSlider: [51, 999],
      workflowDays: 15,
      coolingPeriod: 90
    })
    setPOBenchmarkValue("");
    setPlantData([]);
    setMRPControllerData([]);
    setSupplierData([]);
    setMaterialGroupData([]);
    setMaterialIdData([]);
    setMaterialTypeData([]);
    setPurchasingGroupData([]);
    setScodeData([])
    setShow(false);
    fetchData();
  };

  const isUploadFileSelected = () => {
    setIsWindowFileSelected(true)
  }

  const onClickSearchButton = async () => {
    const materialIds = formData?.materialId?.map(item => item?.value?.split("|")[0]);
    const supplierIds = formData?.supplierId?.map(item => item?.value?.split("|")[0]);

    const searchRequestBody = {
      "plants": plantData,
      "materialIds": materialIds,
      "supplierIds": supplierIds
    }

    try {
      const responseSearchParamConfig = await dispatch(getParamConfigMaterialSearch({
        dynamicEndpoint: `${searchParamConfigEndpoint}`,
        data: searchRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSearchParamConfig.meta.requestStatus === 'fulfilled') {
        setSearchResults(responseSearchParamConfig?.payload);
        setShow(true)
      } else {
        toast.error(responseSearchParamConfig?.error, {
          autoClose: 2000,
        });
        setSearchResults([])
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }
  const onClickSaveManualAPI = async () => {
    const userEmail = localStorage.getItem("data");
    const materialIds = formData?.materialId?.map(item => item?.value?.split("|")[0]);
    const supplierIds = formData?.supplierId?.map(item => item?.value?.split("|")[0]);
    const manualUpdateRequestBody = {
      "userEmail": userEmail,
      "plants": plantData,
      "materialIds": materialIds,
      "supplierIds": supplierIds,
      "isPercent": thresholdValue === "percentage" ? true : false,
      "lowLTVariationA": formData?.lowSlider?.[0],
      "lowLTVariationB": formData?.lowSlider?.[1],
      "mediumLTVariationA": formData?.mediumSlider?.[0],
      "mediumLTVariationB": formData?.mediumSlider?.[1],
      "highLTVariationA": formData?.highSlider?.[0],
      "workflowDays": formData?.workflowDays,
      "coolingPeriod": formData?.coolingPeriod,
      "isManualSave": value === 0 ? true : false,
      "poAdherenceBenchMark": value === 0 ? 0 : poBenchmarkValue
    }
    try {
      const responseSaveParamConfig = await dispatch(postParamConfigSave({
        dynamicEndpoint: `${saveParamConfigEndpoint}`,
        data: manualUpdateRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseSaveParamConfig.meta.requestStatus === 'fulfilled') {
        handleClear();
        toast.success(responseSaveParamConfig?.payload, {
          autoClose: 2000,
        });
      } else {
        toast.error(responseSaveParamConfig?.error, {
          autoClose: 2000,
        });
        setSearchResults([])
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const onHandleClickSave = async () => {
    const userEmail = localStorage.getItem("data");

    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    const uploadSaveUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/admin/uploadLtCsvParamConfig/${userEmail}`;
    setExcelLoader(true);
    axios.post(uploadSaveUrl, xlDetails,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          withCredentials: true,
          "Content-Type": "multipart/form-data",
        },
        params: {
          plant: localStorage.getItem("selectedLTPlantCode"),
          userEmail: localStorage.getItem("data"),
          ltRole: localStorage.getItem("LTRole"),
          cdRole: localStorage.getItem("CDRole"),
          ltRegion: localStorage.getItem("LTRegion")
        }
      }
    )
      .then(function (response) {
        if (response) {
          if (response.status === 200) {
            setExcelLoader(false);
            toast.success("File Uploaded Successfully", {
              autoClose: 2000,
            });
            SetFileOverviewDetails({ headers: response?.headers, data: response?.data });
            setIsWindowFileSelected(false);
          }
        }
      })
      .catch(function (error) {
        setExcelLoader(false);
        if (error?.response?.data?.errorMessage?.includes("Columns are not as expected")) {
          toast.error("Columns are not as expected", {
            autoClose: 2000,
          });
        } else {
          toast.error(error?.response?.data?.errorMessage, {
            autoClose: 2000,
          });
        }
      });
  }

  const handleFormData = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };
  const handleFormDataEdit = (event) => {
    setSelectedEditFormData({ ...selectedEditFormData, [event.target.name]: event.target.value });
    setIsModifiedEditData(true);
  };

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const getFileDetails = async (fileName, formData) => {
    setFileName(fileName);
    setXLDetails(formData);
  }

  const handleSubmit = () => {
    setOpen(false)
  }

  const handleSelectedItemsChange = (name, newSelectedItems) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: newSelectedItems,
    }));
    if (name === "plant") {
      setPlantData([])
      setMRPControllerData([]);
      setScodeData([]);
      setSupplierData([]);
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMaterialTypeData([]);
      setPurchasingGroupData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialType: [],
        supplierId: [],
        mrpController: [],
        materialId: [],
        materialGroup: [],
        purchasingGroup: [],
        scode: []
      }));
      // setPlantData(newSelectedItems.target.value);
      // setPurchasingGroupData(dropdownData?.filter(item => item.plant === newSelectedItems.target.value))

      const filterValues = newSelectedItems?.map((group) => group.value);
      setPlantData(filterValues)
      const filteredPurchasingGroup = dropdownData?.filter((item) =>
        filterValues?.includes(item.plant)
      );
      const uniquePurchasingData =
        filteredPurchasingGroup?.filter((item) => item.purchasingGroup);
      setPurchasingGroupData(uniquePurchasingData)
    }
    if (name === "purchasingGroup") {
      setScodeData([]);
      setMRPControllerData([]);
      setSupplierData([]);
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMaterialTypeData([]);
      setFormData((prevData) => ({
        ...prevData,
        supplierId: [],
        mrpController: [],
        materialId: [],
        materialGroup: [],
        materialType: [],
        scode: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = purchasingGroupData?.filter((item) =>
        filterValues?.includes(item.purchasingGroup)
      );
      const uniqueScodeData =
        filteredPurchasingGroup?.filter((item) => item.scode);
      setScodeData(uniqueScodeData)
    }
    if (name === "scode") {
      setMRPControllerData([]);
      setSupplierData([]);
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMaterialTypeData([]);
      setFormData((prevData) => ({
        ...prevData,
        supplierId: [],
        mrpController: [],
        materialId: [],
        materialGroup: [],
        materialType: [],
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredPurchasingGroup = scodeData?.filter((item) =>
        filterValues?.includes(item.scode)
      );
      const uniqueMaterialTypes =
        filteredPurchasingGroup?.filter((item) => item.materialType);
      setMaterialTypeData(uniqueMaterialTypes)
    }
    if (name === "materialType") {
      setMRPControllerData([]);
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setSupplierData([]);
      setFormData((prevData) => ({
        ...prevData,
        mrpController: [],
        materialId: [],
        materialGroup: [],
        supplierId: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredMaterialTypes = materialTypeData?.filter((item) =>
        filterValues?.includes(item.materialType)
      );
      const uniqueSupplierData =
        filteredMaterialTypes?.filter((item) => item.supplierId);
      setSupplierData(uniqueSupplierData)
    }
    if (name === "supplierId") {
      setMaterialGroupData([]);
      setMaterialIdData([]);
      setMRPControllerData([])
      setFormData((prevData) => ({
        ...prevData,
        materialId: [],
        materialGroup: [],
        mrpController: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredSuppliers = supplierData?.filter((item) =>
        filterValues?.includes(item.supplierId)
      );
      const uniqueMRPController =
        filteredSuppliers?.filter((item) => item.mrpController);
      setMRPControllerData(uniqueMRPController)
    }
    if (name === "mrpController") {
      setMaterialIdData([]);
      setMaterialGroupData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialId: [],
        materialGroup: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredMRPController = mrpControllerData?.filter((item) =>
        filterValues?.includes(item.mrpController)
      );
      const uniqueMaterialGroup =
        filteredMRPController?.filter((item) => item.materialGroup);
      setMaterialGroupData(uniqueMaterialGroup)
    }
    if (name === "materialGroup") {
      setMaterialIdData([]);
      setFormData((prevData) => ({
        ...prevData,
        materialId: []
      }));
      const filterValues = newSelectedItems?.map((group) => group.value);
      const filteredMaterialGroup = materialGroupData?.filter((item) =>
        filterValues?.includes(item.materialGroup)
      );
      const uniqueMaterialID =
        filteredMaterialGroup?.filter((item) => item.materialId);
      setMaterialIdData(uniqueMaterialID)
    }
  }
  const getLowerThresholdValues = (maxValue, interval) => {
    const result = [];
    for (let i = interval; i <= maxValue; i += interval) {
      result.push({ value: i, label: i });
    }
    return result;
  };
  const getSliderData = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  }

  const changeLowSliderEndValue = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      mediumSlider: [prevData.lowSlider?.[1] + 1, prevData.mediumSlider?.[1]],
    }));
  }
  const changeMediumSliderEndValue = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      highSlider: [prevData.mediumSlider?.[1] + 1, prevData.highSlider?.[1]],
    }));
  }
  const fetchData = async () => {
    try {
      const responseParamConfigDropdown = await dispatch(getParamConfigDropdownData({
        dynamicEndpoint: `${getParamConfigDropdownEndpoint}`,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseParamConfigDropdown.meta.requestStatus === 'fulfilled') {
        setDropdownData(responseParamConfigDropdown?.payload);
      } else {
        toast.error(responseParamConfigDropdown?.error, {
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  useEffect(() => {
    if (accounts?.length) {
      fetchData();
    } else {
      console.log("No accounts exist to get access token");
    }
  }, [accounts, instance]);
  const extractRange = (category) => {
    const numbers = category.match(/\d+/g); // Extract numbers
    return numbers ? numbers.map(Number) : []; // Convert to array of numbers
  }
  const extractDigits = (input) => {
    const match = input.match(/\d+/); // Extract only digits
    return match ? parseInt(match[0], 10) : null; // Convert to number
  };
  const onClickEditExistingRecords = (item) => {
    setSelectedEditFormData({
      variationThreshouldEdit: item.data.highLeadTimeVariationCategory.includes("%") ? "percentage" : "No.of Days",
      lowRange1: extractRange(item.data.lowLeadTimeVariationCategory)[0],
      lowRange2: extractRange(item.data.lowLeadTimeVariationCategory)[1],
      mediumRange1: extractRange(item.data.mediumLeadTimeVariationCategory)[0],
      mediumRange2: extractRange(item.data.mediumLeadTimeVariationCategory)[1],
      highRange1: Number(extractDigits(item.data.highLeadTimeVariationCategory)),
      highRange2: 999,
      workflowDays: item.data.overdueWorkflowDays,
      coolingPeriod: item.data.coolingPeriod,
      plant: item.data.plant,
      scode: item.data.scode,
      purchasingGroup: item.data.purchasingGroup,
      materialType: item.data.materialType,
      supplierId: item.data.supplier,
      mrpController: item.data.mrpController,
      materialId: item.data.material,
      materialGroup: item.data.materialGroup,
      uniqueId: item.data.uniqueId

    });
    setEditModalOpen(true);
  }
  const onClickDeleteLineItem = async (item) => {
    const account = instance?.getAllAccounts()[0];
    instance?.setActiveAccount(account);
    const tokenRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    const response = await instance?.acquireTokenSilent(tokenRequest);
    const accessToken = response?.accessToken;
    const deleteUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/admin/deleteLtParamConfig/${item?.data?.uniqueId}`;
    axios.delete(deleteUrl,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          withCredentials: true
        },
        params: {
          plant: localStorage.getItem("selectedLTPlantCode"),
          userEmail: localStorage.getItem("data"),
          ltRole: localStorage.getItem("LTRole"),
          cdRole: localStorage.getItem("CDRole"),
          ltRegion: localStorage.getItem("LTRegion")
        }
      }
    )
      .then(function (response) {
        if (response?.data === "LT Param config deleted successfully") {
          toast.success(response?.data, {
            autoClose: 2000,
          });
          setEditModalOpen(false);
          onClickSearchButton()
        }

      })
      .catch(function (error) {
        console.log(error);
        setEditModalOpen(false);
      });


  }

  const generateDropdownOptions = (start, end) => {
    let result = [];
    for (let i = start; i <= end; i++) {
      result.push({ value: i, label: i });
    }
    return result;
  };

  const RenderEditModalContent = () => {
    const data = selectedEditFormData;
    return (
      <div className='renderEditModalParam_main'>
        <div className='renderEditModal_Headers'>
          <div className='header_box'><b >Plant</b>:<p>{data.plant}</p></div>
          <div className='header_box'><b >Purchasing Group</b>:<p>{data.purchasingGroup}</p></div>
          <div className='header_box'><b >MRP Controller</b>:<p>{data.mrpController}</p></div>
          <div className='header_box'><b >S-Code (Ext Material Group)</b>:<p>{data.scode}</p></div>
          <div className='header_box'><b >Material Type</b>:<p>{data.materialType}</p></div>
          <div className='header_box'><b >Material Group</b>:<p>{data.materialGroup}</p></div>
          <div className='header_box'><b >Material</b>:<p>{data.materialId}</p></div>
          <div className='header_box'><b >Supplier</b>:<p>{data.supplierId}</p></div>
        </div>
        <div className='editMRPdropdown'>
          <div className="threshold-value-container_edit">
            <div className='threshold-section'>
              <p style={{ fontSize: "14px" }}>Threshold Value for Lead Time Variation Alerts:</p>
              <div>
                <RadioButtonGroup name="thresholdValueEdit" value={thresholdValueEdit} onChange={onChangeThresholdValueEdit} props={[
                  { label: 'percentage', value: 'percentage', labelPlacement: 'start', size: 'small' },
                  { label: 'No.of Days', value: 'No.of Days', labelPlacement: 'start', size: 'small' },
                ]} />
              </div>
            </div>

            <div className='variationRanges_class'>
              <div className='variationRanges_main'>
                <div className='range_div1'></div>
                <div className='range_div2'><b>Range 1</b></div>
                <div className='range_div3'><b>Range 2</b></div>
              </div>
              <div className='variationRanges_main'>
                <div className='range_div1'>Low Lead Time Variation</div>
                <div className='range_div2'>
                  <Dropdown
                    maxWidth="200px"
                    value={selectedEditFormData.lowRange1}
                    name="lowRange1"
                    options={generateDropdownOptions(0, selectedEditFormData.lowRange2 - 1)}
                    handleChange={(e) => handleChangeEditDropdown("lowRange1", e.target.value)}
                  /></div>
                <div className='range_div3'>
                  <Dropdown
                    maxWidth="200px"
                    value={selectedEditFormData.lowRange2}
                    name="lowRange2"
                    options={generateDropdownOptions(selectedEditFormData.lowRange1 + 1, thresholdValueEdit === "percentage" ? 20 : 150)}
                    handleChange={(e) => handleChangeEditDropdown("lowRange2", e.target.value)}
                  /></div>
              </div>
              <div className='variationRanges_main'>
                <div className='range_div1'>Medium Lead Time Variation</div>
                <div className='range_div2'>
                  <TextInput
                    width="200px"
                    name="mediumRange1"
                    value={selectedEditFormData.mediumRange1}
                    disabled={true}
                  />
                </div>
                <div className='range_div3'>
                  <Dropdown
                    maxWidth="200px"
                    value={selectedEditFormData.mediumRange2}
                    name="mediumRange2"
                    options={generateDropdownOptions(selectedEditFormData.mediumRange1 + 1, thresholdValueEdit === "percentage" ? 50 : 225)}
                    handleChange={(e) => handleChangeEditDropdown("mediumRange2", e.target.value)}
                  /></div>
              </div>
              <div className='variationRanges_main'>
                <div className='range_div1'>High Lead Time Variation</div>
                <div className='range_div2'>
                  <TextInput
                    width="200px"
                    name="highRange1"
                    value={selectedEditFormData.highRange1}
                    disabled={true}
                  />
                </div>
                <div className='range_div3'>
                  <TextInput
                    width="200px"
                    name="highRange2"
                    value={selectedEditFormData.highRange2}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            <div className="parameter-items">
              <div className="parameter-dropdowns">
                <span>Workflow Days to consider for overdue </span>
                <Dropdown
                  maxWidth="200px"
                  value={selectedEditFormData.workflowDays}
                  name="workflowDays"
                  options={getLowerThresholdValues(60, 1)}
                  handleChange={handleFormDataEdit}
                />
              </div>
              <div className="parameter-dropdowns">
                <span>Cooling Period in Days</span>
                <Dropdown
                  maxWidth="200px"
                  value={selectedEditFormData.coolingPeriod}
                  name="coolingPeriod"
                  options={getLowerThresholdValues(360, 10)}
                  handleChange={handleFormDataEdit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
  const RenderEditModalFooter = () => {
    return (
      <div style={{ display: 'flex', gap: 10 }}>
        <ButtonComponent
          maxWidth="170px"
          label="Cancel"
          bgColor="white"
          color="black"
          onClick={onCloseEditModal}
        />
        <ButtonComponent
          maxWidth="170px"
          label="Submit"
          bgColor="black"
          color="white"
          onClick={handleEditModelSubmitButton}
          disabled={!isModifiedEditData}
        />
      </div>
    )
  }

  const onCloseEditModal = () => {
    setEditModalOpen(false);
  }
  const handleEditModelSubmitButton = async () => {
    const userEmail = localStorage.getItem("data");

    const editModalParamConfigRequestBody = {
      "userEmail": userEmail,
      "isPercent": thresholdValueEdit === "percentage" ? true : false,
      "lowLTVariationA": selectedEditFormData?.lowRange1,
      "lowLTVariationB": selectedEditFormData?.lowRange2,
      "mediumLTVariationA": selectedEditFormData?.mediumRange1,
      "mediumLTVariationB": selectedEditFormData?.mediumRange2,
      "highLTVariationA": selectedEditFormData?.highRange1,
      "workflowDays": selectedEditFormData?.workflowDays,
      "coolingPeriod": selectedEditFormData?.coolingPeriod,
    }

    try {
      const responseUpdateParamConfig = await dispatch(updateParamConfigSearch({
        dynamicEndpoint: `${updateParamConfigSearchEndpoint}/${selectedEditFormData.uniqueId}`,
        data: editModalParamConfigRequestBody,
        params: {
          plant: localStorage.getItem("selectedLTPlantCode")
        }
      }));
      if (responseUpdateParamConfig.meta.requestStatus === 'fulfilled') {
        toast.success(responseUpdateParamConfig?.payload, {
          autoClose: 2000,
        });
        setEditModalOpen(false);
        onClickSearchButton()
      } else {
        toast.error(responseUpdateParamConfig?.error, {
          autoClose: 2000,
        });
        setEditModalOpen(false);
      }
    } catch (error) {
      console.error('API error:', error);
    }
  }

  const editModelColumn = EditParameterConfigHeaders(onClickEditExistingRecords, onClickDeleteLineItem, value, userRole);
  const gridOptions = {
    getRowId: (params) => {
      return params?.data?.uniqueId
    },
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              suppressMiniFilter: false,
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              excelMode: 'windows',
              suppressMiniFilter: false,
              buttons: ['apply', 'reset'],
            },
          },
        ],
      },
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === "" ? "-" : value;
      },
    }
  }

  const handlePOBenchmarkChange = (event) => {
    setPOBenchmarkValue(event.target.value);
  }

  return (
    (stateSelector?.ParamConfigDropdownDataSlice?.loading || stateSelector?.ParamConfigSaveSlice?.loading || stateSelector?.paramConfigUpdateSlice?.loading) ?
      <Loader />
      :
      <>
        <TopSection
          tabTitle="Parameter Configuration"
          labelList={[
            { title: "Home", path: "/landing-page" },
            { title: "Parameter Configuration" },
          ]} />
        <div className="main-container paramaeter-tab-container">
          <div className="tab-part">
            <TabSection
              style={{ maxWidth: "550px", marginBottom: "30px", width: "100%",}}
              label={["Manual Update", "Excel Update", "PO Adherence"]}
              value={value}
              handleChange={handleChange}
              disabledTabs={(userRole === "Viewer" && pagePath === "/viewer-analytics-results") ? [1] : []}
            />
            {value === 0 ?
              (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Plant</span>
                        {/* <Dropdown
                          maxWidth="100%"
                          label="Select Plant"
                          value={plantData || ""}
                          name="plant"
                          options={getUniqueValues(dropdownData, 'plant')}
                          handleChange={(event) => handleSelectedItemsChange('plant', event)}
                        /> */}
                        <MultiDropdown
                          id="plant"
                          name="plant"
                          options={getUniqueValues(dropdownData, 'plant') || []}
                          selectedItemsData={formData?.plant || []}
                          onChangeItems={handleSelectedItemsChange}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Purchasing Group</span>
                        <MultiDropdown
                          id="purchasingGroup"
                          name="purchasingGroup"
                          options={getUniqueValues(purchasingGroupData, 'purchasingGroup')}
                          selectedItemsData={formData?.purchasingGroup}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.plant?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>S-Code (Ext Material Group)</span>
                        <MultiDropdown
                          id="scode"
                          name="scode"
                          options={getUniqueValues(scodeData, 'scode')}
                          selectedItemsData={formData?.scode}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.purchasingGroup?.length === 0}
                        />
                      </div>

                    </div>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Material Type</span>
                        <MultiDropdown
                          id="materialType"
                          name="materialType"
                          options={getUniqueValues(materialTypeData, 'materialType')}
                          selectedItemsData={formData?.materialType}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.scode?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Supplier</span>
                        <MultiDropdown
                          id="supplierId"
                          name="supplierId"
                          options={getUniqueValues(supplierData, 'supplierId')}
                          selectedItemsData={formData?.supplierId}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.materialType?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>MRP Controller</span>
                        <MultiDropdown
                          id="mrpController"
                          name="mrpController"
                          options={getUniqueValues(mrpControllerData, 'mrpController')}
                          selectedItemsData={formData?.mrpController}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.supplierId?.length === 0}
                        />
                      </div>
                    </div>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Material Group</span>
                        <MultiDropdown
                          id="materialGroup"
                          name="materialGroup"
                          options={getUniqueValues(materialGroupData, 'materialGroup')}
                          selectedItemsData={formData?.materialGroup}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.mrpController?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Material</span>
                        <MultiDropdown
                          id="materialId"
                          name="materialId"
                          options={getUniqueValues(materialIdData, 'materialId')}
                          selectedItemsData={formData?.materialId}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.materialGroup?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns"></div>
                    </div>
                    <div className="parameter-dropdowns" style={{ justifyContent: 'center', marginTop: 25, textAlign: 'center' }}>
                      <ButtonComponent
                        type="secondary"
                        maxWidth="120px"
                        label="Search"
                        height="40px"
                        onClick={onClickSearchButton}
                        disabled={formData?.materialId?.length === 0}
                      />
                    </div>
                    {stateSelector?.ParamConfigSearchMaterialSlice?.loading ? <Loader /> :
                      <div style={{ margin: '10px 0px' }}>
                        {searchResults?.length > 0 && show && value === 0 && <DataTable
                          height={searchResults?.length <= 2 ? 220 : 400}
                          columns={editModelColumn}
                          gridOptions={gridOptions}
                          rows={searchResults}
                          paginationProp={pagination}
                          paginationPageSize={paginationPageSize}
                          paginationPageSizeSelector={paginationPageSizeSelector}

                        />}
                        {searchResults && Object?.keys(searchResults).length === 0 && show && value === 0 ?
                          <div style={{ margin: '20px 5px', border: '1px solid #bcbcbc' }}><p style={{ textAlign: 'center' }}>No Data Found</p></div> :
                          <></>}
                      </div>
                    }

                  </div>
                  <div className="threshold-value-container">
                    <div className='threshold-section'>
                      <p style={{ fontSize: "14px" }}>Threshold Value for Lead Time Variation Alerts:</p>
                      <div>
                        <RadioButtonGroup name="thresholdValue" value={thresholdValue} onChange={onChangeThresholdValue} props={[
                          { label: 'percentage', value: 'percentage', labelPlacement: 'start', size: 'small', },
                          { label: 'No.of Days', value: 'No.of Days', labelPlacement: 'start', size: 'small', },
                        ]} />
                      </div>
                    </div>
                    <div className="lead-time-category">
                      <div className="paramaeter-tab-container lead-time-category-container">
                        <div className="lead-time-category-items">
                          <p >Low Lead Time Variation</p>
                          <CustomSlider width="300px" intialStartvalue={formData?.lowSlider?.[0] || 0} intialEndvalue={formData?.lowSlider?.[1] || (thresholdValue === "percentage" ? 20 : 150)} initialValue={thresholdValue === "percentage" ? [0, 20] : [0, 150]} getSliderData={getSliderData} name="lowSlider" disabled={userRole === "Viewer"} thresholdValue={thresholdValue} formData={formData} changeLowSliderEndValue={changeLowSliderEndValue} />
                        </div>
                      </div>
                      <div className="paramaeter-tab-container lead-time-category-container">
                        <div className="lead-time-category-items">
                          <p >Medium Lead Time Variation</p>
                          <CustomSlider width="300px" intialStartvalue={formData?.mediumSlider?.[0] || (formData?.lowSlider?.[1] + 1 || (thresholdValue === "percentage" ? 21 : 151))} intialEndvalue={formData?.mediumSlider?.[1] || (thresholdValue === "percentage" ? 50 : 225)} initialValue={thresholdValue === "percentage" ? [formData?.lowSlider?.[1] + 1, 50] : [formData?.lowSlider?.[1] + 1, 225]} getSliderData={getSliderData} name="mediumSlider" disabled={userRole === "Viewer"} thresholdValue={thresholdValue} formData={formData} changeMediumSliderEndValue={changeMediumSliderEndValue} />
                        </div>
                      </div>
                      <div className="paramaeter-tab-container lead-time-category-container">
                        <div className="lead-time-category-items">
                          <p >High Lead Time Variation</p>
                          <CustomSlider width="300px" intialStartvalue={formData?.highSlider?.[0] || formData?.mediumSlider?.[1] + 1 || (thresholdValue === "percentage" ? 51 : 226)} intialEndvalue={999} getSliderData={getSliderData} name="highSlider" disabled={true} initialValue={thresholdValue === "percentage" ? [formData?.mediumSlider?.[1] + 1, 999] : [formData?.mediumSlider?.[1] + 1, 999]} thresholdValue={thresholdValue} formData={formData} />
                        </div>
                      </div>
                    </div>
                    <div className="parameter-items">
                      <div className="parameter-dropdowns">
                        <span>Workflow Days to consider for overdue </span>
                        <Dropdown
                          maxWidth="200px"
                          value={formData.workflowDays}
                          name="workflowDays"
                          options={getLowerThresholdValues(60, 1)}
                          handleChange={handleFormData}
                          disabled={userRole === "Viewer"}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Cooling Period in Days</span>
                        <Dropdown
                          maxWidth="200px"
                          value={formData.coolingPeriod}
                          name="coolingPeriod"
                          options={getLowerThresholdValues(360, 10)}
                          handleChange={handleFormData}
                          disabled={userRole === "Viewer"}
                        />
                      </div>
                    </div>
                  </div>
                </>
              ) :
              value === 1 ?
              (
                <>
                  <ExcelUpdate getFileDetails={getFileDetails} templateName={"ParameterTemplate"} url={"/api/admin/downloadLtParamConfigCsv"} isUploadFileSelected={isUploadFileSelected} excelLoader={excelLoader} />
                </>
              ) : 
              (
                <>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Plant</span>
                        <MultiDropdown
                          id="plant"
                          name="plant"
                          options={getUniqueValues(dropdownData, 'plant') || []}
                          selectedItemsData={formData?.plant || []}
                          onChangeItems={handleSelectedItemsChange}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Purchasing Group</span>
                        <MultiDropdown
                          id="purchasingGroup"
                          name="purchasingGroup"
                          options={getUniqueValues(purchasingGroupData, 'purchasingGroup')}
                          selectedItemsData={formData?.purchasingGroup}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.plant?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>S-Code (Ext Material Group)</span>
                        <MultiDropdown
                          id="scode"
                          name="scode"
                          options={getUniqueValues(scodeData, 'scode')}
                          selectedItemsData={formData?.scode}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.purchasingGroup?.length === 0}
                        />
                      </div>

                    </div>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Material Type</span>
                        <MultiDropdown
                          id="materialType"
                          name="materialType"
                          options={getUniqueValues(materialTypeData, 'materialType')}
                          selectedItemsData={formData?.materialType}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.scode?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Supplier</span>
                        <MultiDropdown
                          id="supplierId"
                          name="supplierId"
                          options={getUniqueValues(supplierData, 'supplierId')}
                          selectedItemsData={formData?.supplierId}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.materialType?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>MRP Controller</span>
                        <MultiDropdown
                          id="mrpController"
                          name="mrpController"
                          options={getUniqueValues(mrpControllerData, 'mrpController')}
                          selectedItemsData={formData?.mrpController}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.supplierId?.length === 0}
                        />
                      </div>
                    </div>
                    <div className="parameter-items" >
                      <div className="parameter-dropdowns">
                        <span>Material Group</span>
                        <MultiDropdown
                          id="materialGroup"
                          name="materialGroup"
                          options={getUniqueValues(materialGroupData, 'materialGroup')}
                          selectedItemsData={formData?.materialGroup}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.mrpController?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns">
                        <span>Material</span>
                        <MultiDropdown
                          id="materialId"
                          name="materialId"
                          options={getUniqueValues(materialIdData, 'materialId')}
                          selectedItemsData={formData?.materialId}
                          onChangeItems={handleSelectedItemsChange}
                          disabled={formData?.materialGroup?.length === 0}
                        />
                      </div>
                      <div className="parameter-dropdowns"></div>
                    </div>
                    <div className="parameter-dropdowns" style={{ justifyContent: 'center', marginTop: 25, textAlign: 'center' }}>
                      <ButtonComponent
                        type="secondary"
                        maxWidth="120px"
                        label="Search"
                        height="40px"
                        onClick={onClickSearchButton}
                        disabled={formData?.materialId?.length === 0}
                      />
                    </div>
                    {stateSelector?.ParamConfigSearchMaterialSlice?.loading ? <Loader /> :
                      <div style={{ margin: '10px 0px' }}>
                        {searchResults?.length > 0 && show && value === 2 && <DataTable
                          height={searchResults?.length <= 2 ? 220 : 400}
                          columns={editModelColumn}
                          gridOptions={gridOptions}
                          rows={searchResults}
                          paginationProp={pagination}
                          paginationPageSize={paginationPageSize}
                          paginationPageSizeSelector={paginationPageSizeSelector}

                        />}
                        {searchResults && Object?.keys(searchResults).length === 0 && show && value === 2 ?
                          <div style={{ margin: '20px 5px', border: '1px solid #bcbcbc' }}><p style={{ textAlign: 'center' }}>No Data Found</p></div> :
                          <></>}
                      </div>
                    }

                  </div>
                  <div className="threshold-value-container">
                    <div className='threshold-section'>
                      <Grid
                        item
                        md={4}
                        xs={12}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          "& .MuiFormControl-root": { width: "100%" },
                          "& .MuiFormLabel-root": { fontSize: "14px" },
                          "& .MuiInputBase-root>Input": { height: "80% !important" },
                        }}
                      >
                        <label className="label-position" htmlFor="hierarchy">
                          PO Adherence Benchmark (%)
                        </label>
                        <TextInput
                          name="poAdherenceBenchmark"
                          type="number"
                          value={poBenchmarkValue}
                          onChange={handlePOBenchmarkChange}
                          disabled= {userRole === "Viewer"}
                        />
                      </Grid>
                    </div>
                  </div>
                </>
              )
            }
          </div>

        </div>
        {
          userRole !== "Viewer" && 
        <div style={{ display: "flex", padding: "10px" }} >
          <div style={{ display: "flex", width: "30%" }}>
            {/* <ButtonComponent
              type="primary"
              maxWidth="80px"
              label="Back"
            /> */}
          </div>
          {value === 0 ?
            (
              <div className="button-alignment" style={{ width: "70%" }}>
                <ButtonComponent
                  type="primary"
                  maxWidth="120px"
                  label="Clear All"
                  onClick={handleClear}
                />
                <ButtonComponent
                  type="secondary"
                  maxWidth="80px"
                  label="Save"
                  disabled={formData?.materialId?.length === 0}
                  onClick={onClickSaveManualAPI}
                />
              </div>
            ) :
            value === 1 ?
            (
              <div className="button-alignment" style={{ width: "70%" }}>
                <ButtonComponent
                  type="primary"
                  maxWidth="180px"
                  label="File Upload Overview"
                  disabled={isWindowFileSelected || excelLoader}
                  onClick={handleClickOpen}
                />
                <Modal open={open} handleClose={handleClose} title="File Upload Overview" action={<FileOverivewFooter close={handleClose} submit={handleSubmit} />} content={<FileOverivew fileName={fileName} fileOverviewDetails={fileOverviewDetails} />} maxWidth="100px" />
                <ButtonComponent
                  type="secondary"
                  maxWidth="80px"
                  label="Save"
                  disabled={!fileName || excelLoader}
                  onClick={onHandleClickSave}
                />
              </div>
            ) :
            ( 
              <div className="button-alignment" style={{ width: "70%" }}>
                <ButtonComponent
                  type="primary"
                  maxWidth="120px"
                  label="Clear All"
                  onClick={handleClear}
                />
                <ButtonComponent
                  type="secondary"
                  maxWidth="80px"
                  label="Save"
                  disabled={formData?.materialId?.length === 0}
                  onClick={onClickSaveManualAPI}
                />
              </div>
            )
          }

        </div>
        }
        <Modal title="Edit"
          open={editModalOpen}
          handleClose={onCloseEditModal}
          content={
            <RenderEditModalContent />
          }
          action={
            <RenderEditModalFooter />
          }
          maxWidth="lg"
        />
      </>

  )
}

export default ParamaterConfiguration;